var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalGestionBarquettes",
      attrs: {
        size: "s",
        title: _vm.titreModal,
        "ok-title": _vm.titreBoutonOk,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        ok: function($event) {
          return _vm.enregistrerBarquette()
        },
        show: function($event) {
          return _vm.initialiserModale()
        },
        hidden: function($event) {
          return _vm.quitterModale()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "designationBarquette" } }, [
              _vm._v("Désignation")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.barquette.designation,
                  expression: "barquette.designation",
                  modifiers: { trim: true }
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                id: "designationBarquette",
                type: "text",
                title: "Description/modèle de la barquette"
              },
              domProps: { value: _vm.barquette.designation },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.barquette,
                      "designation",
                      $event.target.value.trim()
                    )
                  },
                  function($event) {
                    _vm.key++
                  }
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            !_vm.barquette.designation
              ? _c("div", { staticClass: "error" }, [
                  _vm._v("Ce champ est requis")
                ])
              : _c("div", [_vm._v(" ")])
          ]),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "tailleBarquette" } }, [
                _vm._v("Taille (Nombre de portions)")
              ]),
              _c("br"),
              _c("InputNumber", {
                staticStyle: { width: "48px" },
                attrs: { id: "tailleBarquette", typeFiltre: "quantiteEntiere" },
                on: {
                  input: function($event) {
                    _vm.key++
                  }
                },
                model: {
                  value: _vm.barquette.taille,
                  callback: function($$v) {
                    _vm.$set(_vm.barquette, "taille", $$v)
                  },
                  expression: "barquette.taille"
                }
              }),
              !_vm.barquette.taille
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _c("div", [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Active")]),
              _c("br"),
              _c("ToggleButton", {
                attrs: {
                  labels: { checked: "Oui", unchecked: "Non" },
                  color: { checked: "#16D39A", unchecked: "#CCCCCC" },
                  height: 30,
                  width: 85
                },
                model: {
                  value: _vm.barquette.active,
                  callback: function($$v) {
                    _vm.$set(_vm.barquette, "active", $$v)
                  },
                  expression: "barquette.active"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }